(function () {
  'use strict';

  // Smooth-scroll for in-page anchors within the members section
  document.querySelectorAll('.pl-mem a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target.tagName === 'DETAILS') {
        target.open = true;
      }
    });
  });

  // FAQ — close siblings when one opens (accordion behavior)
  var faqWraps = document.querySelectorAll('[data-pl-mem-faq]');
  faqWraps.forEach(function (wrap) {
    var items = wrap.querySelectorAll('details.pl-mem__faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });
})();
